var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import _chunk from "lodash/chunk";
import _defaultsDeep from "lodash/defaultsDeep";
import { CUJStatus, LoggingModule } from "@pns-fe/sdk-common-modules";
import { CUJEvents } from "../../constants/cujEvents";
import { Region } from "../../constants/env";
import { ErrorList } from "../../constants/error";
import { ConsentStatus, ConsentStatusParam, STATUS_MAP } from "../../constants/sdk";
import { formatError } from "../../utils/ErrorUtil";
import ServiceModule from "../service-module";
import StorageModule from "../storage-module";
const DEFAULT_MAX_PAGE_SIZE = 20;
const DEFAULT_VERSION = {
  fetchEntities: {},
  fetchCollectionPoint: {},
  updateRecords: {}
};
class ConsentModule {
  constructor() {
    this._validateStatus = (status) => {
      return Object.keys(ConsentStatusParam).map((key) => ConsentStatusParam[key]).includes(status);
    };
    this._validateEntityKeys = (entityKeys) => {
      return (entityKeys == null ? void 0 : entityKeys.length) > 0 && entityKeys.every((key) => {
        if (!this._validateEntityKey(key)) {
          return false;
        }
        return true;
      });
    };
    this._validateEntityKey = (entityKey) => {
      return /^(conditions|permissions|data)/.test(entityKey);
    };
    this._validateUserInfo = (userInfo) => {
      if (!(userInfo == null ? void 0 : userInfo.user_id) && !(userInfo == null ? void 0 : userInfo.device_id)) {
        LoggingModule.error("[ConsentModule]: updateRecords - invalid user info");
        throw formatError(ErrorList.INVALID_USER_INFO);
      }
    };
    this._validateUpdateParam = (params) => {
      return (params == null ? void 0 : params.length) > 0 && params.every((param) => {
        if (!param) {
          return false;
        }
        const { key, status } = param;
        if (!/^(conditions|permissions|data)/.test(key)) {
          return false;
        }
        if (!this._validateStatus(status)) {
          return false;
        }
        return true;
      });
    };
    this._formatExtra = (domain, extra) => {
      let extraObj = {};
      try {
        const decodedObj = JSON.parse(extra != null ? extra : "");
        extraObj = __spreadValues({}, decodedObj);
      } catch (e) {
      }
      if (this._debug) {
        extraObj = __spreadProps(__spreadValues({}, extraObj), {
          appId: this._appId,
          domain: domain || this._domain,
          tenant: this._tenant,
          path: "/consent/api/record/create/v2",
          debug: true,
          vregion: this._vregion
        });
      }
      return JSON.stringify(extraObj);
    };
    this.destruct = () => {
      LoggingModule.info("[ConsentModule]: destruct");
    };
  }
  _getAPIConfig(methodName) {
    var _a, _b;
    let apiConfig = {};
    if ((_a = this._config) == null ? void 0 : _a[methodName]) {
      if (typeof this._config[methodName] === "function") {
        apiConfig = this._config[methodName]();
      } else {
        apiConfig = (_b = this._config[methodName]) != null ? _b : {};
      }
    }
    return apiConfig;
  }
  init(config) {
    LoggingModule.info("[ConsentModule]: init");
    const { api, appId, debug, domain, tenant, region } = config != null ? config : {};
    this._appId = appId;
    this._debug = debug != null ? debug : false;
    this._domain = domain;
    this._tenant = tenant;
    this._vregion = region != null ? region : Region.SINGAPORE_CENTRAL;
    const { consent } = api != null ? api : {};
    this._config = _defaultsDeep({}, consent, DEFAULT_VERSION);
  }
  getRecord(entityKey, userInfo) {
    LoggingModule.info("[ConsentModule]: getRecord", { entityKey, userInfo });
    return StorageModule.getRecord(entityKey, userInfo);
  }
  getRecords(entityKeys, userInfo) {
    LoggingModule.info("[ConsentModule]: getRecords", { entityKeys, userInfo });
    return StorageModule.getRecords(entityKeys, userInfo);
  }
  getEntity(entityKey, userInfo) {
    LoggingModule.info("[ConsentModule]: getEntity", { entityKey, userInfo });
    return StorageModule.getEntity(entityKey, userInfo);
  }
  getEntities(entityKeys, userInfo) {
    LoggingModule.info("[ConsentModule]: getEntities", { entityKeys, userInfo });
    return StorageModule.getEntities(entityKeys, userInfo);
  }
  fetchEntities(entityKeys, userInfo) {
    return __async(this, null, function* () {
      LoggingModule.info("[ConsentModule]: fetchEntities", { entityKeys, userInfo });
      this._validateUserInfo(userInfo);
      if (!this._validateEntityKeys(entityKeys)) {
        throw formatError(ErrorList.INVALID_PARAM, {
          entityKeys
        });
      }
      LoggingModule.reportCUJ(CUJEvents.FETCH_ENTITIES, CUJStatus.IN_PROGRESS, {
        stepName: "api"
      });
      const { domain = "", timeout, requestConfig, pageSize } = this._getAPIConfig("fetchEntities");
      if (pageSize && pageSize > DEFAULT_MAX_PAGE_SIZE) {
        throw formatError(ErrorList.ENTITY_MAX_PAGE_SIZE);
      }
      const consentData = {
        entityMap: {},
        collectionPoint: null
      };
      let now = (/* @__PURE__ */ new Date()).getTime();
      const promises = (pageSize ? _chunk(entityKeys, pageSize) : [entityKeys]).map((subKeys) => {
        LoggingModule.reportCUJ(CUJEvents.FETCH_ENTITIES, CUJStatus.IN_PROGRESS, {
          stepName: "pagination_api"
        });
        return this._fetchEntitiesWithPagination(subKeys, userInfo, domain, pageSize, timeout, "", requestConfig).then((res) => {
          var _a, _b;
          const {
            data: entities,
            status_code: statusCode,
            status_msg: statusMessage,
            extra
          } = (_a = res == null ? void 0 : res.data) != null ? _a : {};
          if (statusCode === 0) {
            LoggingModule.reportCUJ(CUJEvents.FETCH_ENTITIES, CUJStatus.IN_PROGRESS, {
              stepName: "pagination_api_finish"
            });
            const entityMapWithPagination = (_b = entities == null ? void 0 : entities.reduce) == null ? void 0 : _b.call(entities, (map, entity) => {
              const { key } = entity != null ? entity : {};
              if (key) {
                map[key] = entity;
              }
              return map;
            }, {});
            consentData.entityMap = __spreadValues(__spreadValues({}, consentData.entityMap), entityMapWithPagination != null ? entityMapWithPagination : {});
            if ((extra == null ? void 0 : extra.now) && now < extra.now) {
              now = extra.now;
            }
          } else {
            throw formatError(ErrorList.INVALID_RESPONSE, {
              entityKey: subKeys,
              statusCode,
              statusMessage
            });
          }
        }).catch((e) => {
          LoggingModule.error("[ConsentModule]: fetchEntities - fail to fetch", e);
          throw e;
        });
      });
      return Promise.all(promises).then((res) => {
        LoggingModule.reportCUJ(CUJEvents.FETCH_ENTITIES, CUJStatus.IN_PROGRESS, {
          stepName: "api_finish"
        });
        StorageModule.insertConsentData(consentData, now, userInfo);
        LoggingModule.reportCUJ(CUJEvents.FETCH_ENTITIES, CUJStatus.IN_PROGRESS, {
          stepName: "storage"
        });
        return consentData;
      }).catch((e) => {
        LoggingModule.error("[ConsentModule]: fetch - fail to fetch", e);
        throw e;
      });
    });
  }
  getCollectionPoint(collectionPointId, userInfo) {
    LoggingModule.info("[ConsentModule]: getCollectionPoint", { collectionPointId, userInfo });
    return StorageModule.getCollectionPoint(collectionPointId, userInfo);
  }
  fetchCollectionPoint(collectionPointId, userInfo) {
    return __async(this, null, function* () {
      LoggingModule.info("[ConsentModule]: fetchCollectionPoint", { collectionPointId, userInfo });
      this._validateUserInfo(userInfo);
      if (!collectionPointId) {
        throw formatError(ErrorList.INVALID_PARAM, {
          collectionPointId
        });
      }
      LoggingModule.reportCUJ(CUJEvents.FETCH_COLLECTION_POINT, CUJStatus.IN_PROGRESS, {
        stepName: "api"
      });
      const { domain = "", timeout, requestConfig } = this._getAPIConfig("fetchCollectionPoint");
      return ServiceModule.sendRequest(
        `${domain}/consent/api/collection-point-records/list/v1`,
        "POST",
        {
          collection_point_id: collectionPointId
        },
        __spreadProps(__spreadValues({}, requestConfig), {
          timeout,
          params: __spreadValues({}, userInfo)
        })
      ).then((res) => {
        var _a, _b, _c;
        const {
          data: entities = [],
          collection_point: collectionPoint = null,
          status_code: statusCode,
          status_msg: statusMessage,
          extra
        } = (_a = res == null ? void 0 : res.data) != null ? _a : {};
        if (statusCode === 0) {
          LoggingModule.reportCUJ(CUJEvents.FETCH_COLLECTION_POINT, CUJStatus.IN_PROGRESS, {
            stepName: "api_finish"
          });
          let entityMap = null;
          if (collectionPoint) {
            entityMap = (_b = entities == null ? void 0 : entities.reduce((map, entity) => {
              const { key } = entity != null ? entity : {};
              if (key) {
                map[key] = entity;
              }
              return map;
            }, {})) != null ? _b : null;
            StorageModule.insertConsentData(
              {
                entityMap,
                collectionPoint
              },
              (_c = extra == null ? void 0 : extra.now) != null ? _c : Date.now(),
              userInfo
            );
            LoggingModule.reportCUJ(CUJEvents.FETCH_COLLECTION_POINT, CUJStatus.IN_PROGRESS, {
              stepName: "storage"
            });
          }
          return {
            collectionPoint,
            entityMap
          };
        } else {
          throw formatError(ErrorList.INVALID_RESPONSE, {
            collectionPointId,
            statusCode,
            statusMessage
          });
        }
      }).catch((e) => {
        LoggingModule.error("[ConsentModule]: fetchCollectionPoint - fail to fetch", e);
        throw e;
      });
    });
  }
  getEntitiesWithApprovedRecord(entityKeys, userInfo) {
    LoggingModule.info("[ConsentModule]: getEntitiesWithApprovedRecord", { entityKeys, userInfo });
    const { entityMap } = StorageModule.getEntities(entityKeys, userInfo);
    if (entityMap) {
      const entities = Object.keys(entityMap).map((key) => {
        var _a;
        const entity = entityMap[key];
        if (((_a = entity == null ? void 0 : entity.record) == null ? void 0 : _a.status) === ConsentStatus.APPROVE) {
          return entity;
        } else {
          return null;
        }
      }).filter((entity) => entity);
      return entities;
    }
    return [];
  }
  shouldFetch() {
    LoggingModule.info("[ConsentModule]: shouldFetch");
    return true;
  }
  _fetchEntitiesWithPagination(entityKeys, userInfo, domain, pageSize, timeout, pageToken, requestConfig) {
    return ServiceModule.sendRequest(
      `${domain}/consent/api/combine/list/v3`,
      "POST",
      __spreadValues({
        entity_keys: entityKeys
      }, pageSize ? {
        page_size: pageSize,
        page_token: pageToken != null ? pageToken : ""
      } : {}),
      __spreadProps(__spreadValues({}, requestConfig), {
        timeout,
        params: __spreadValues({}, userInfo)
      })
    );
  }
  updateRecords(params, userInfo) {
    return __async(this, null, function* () {
      LoggingModule.info("[ConsentModule]: updateRecords");
      this._validateUserInfo(userInfo);
      if (!this._validateUpdateParam(params)) {
        LoggingModule.error("[ConsentModule]: updateRecords - invalid param", { params });
        throw formatError(ErrorList.INVALID_PARAM, {
          params
        });
      }
      LoggingModule.reportCUJ(CUJEvents.UPDATE_RECORD, CUJStatus.IN_PROGRESS, {
        stepName: "api"
      });
      const { domain = "", timeout, requestConfig } = this._getAPIConfig("updateRecords");
      const entityKeys = params.map((param) => param.key);
      const formattedParams = params.map((param) => {
        var _a;
        return {
          entity_key: param.key,
          status: param.status,
          coll_point_id: param.collectionPointId,
          extra: this._formatExtra(domain, (_a = param.extra) != null ? _a : "")
        };
      });
      return ServiceModule.sendRequest(
        `${domain}/consent/api/record/create/v2`,
        "POST",
        {
          records: formattedParams
        },
        __spreadProps(__spreadValues({}, requestConfig != null ? requestConfig : {}), {
          timeout,
          params: __spreadValues({}, userInfo)
        })
      ).then((res) => {
        var _a;
        const {
          status_code: statusCode,
          status_msg: statusMessage,
          extra = {
            now: Date.now()
          }
        } = (_a = res == null ? void 0 : res.data) != null ? _a : {};
        if (statusCode === 0) {
          LoggingModule.reportCUJ(CUJEvents.UPDATE_RECORD, CUJStatus.IN_PROGRESS, {
            stepName: "api_finish"
          });
          if (params.length) {
            const entityMap = params.reduce((map, record) => {
              var _a2;
              map[record.key] = {
                key: record.key,
                record: {
                  entity_key: record.key,
                  status: STATUS_MAP[record.status],
                  extra: this._formatExtra(domain, record.extra),
                  coll_point_id: record.collectionPointId,
                  app_id: this._appId,
                  created_at: (_a2 = extra == null ? void 0 : extra.now) != null ? _a2 : Date.now()
                }
              };
              return map;
            }, {});
            StorageModule.insertConsentData(
              {
                entityMap,
                collectionPoint: null
              },
              extra.now,
              userInfo
            );
            LoggingModule.reportCUJ(CUJEvents.UPDATE_RECORD, CUJStatus.IN_PROGRESS, {
              stepName: "storage"
            });
          }
          return StorageModule.getEntities(entityKeys, userInfo);
        } else {
          throw formatError(ErrorList.INVALID_RESPONSE, {
            params,
            statusCode,
            statusMessage
          });
        }
      }).catch((e) => {
        LoggingModule.error("[ConsentModule]: updateRecords - fail to create records", e);
        throw e;
      });
    });
  }
}
var ConsentModule_default = ConsentModule;
export {
  DEFAULT_MAX_PAGE_SIZE,
  DEFAULT_VERSION,
  ConsentModule_default as default
};
